export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const USER_URLS = {
    ADD_USER: `${BASE_URL}/adduser`,
    EDIT_USER: `${BASE_URL}/edituser`,
    FETCH_USERS: `${BASE_URL}/getusers`,
    DELETE_USER: `${BASE_URL}/deleteuser`,
};

export const ROLE_URLS = {
    FETCH_ROLES: `${BASE_URL}/getUserRoles`,
    ADD_USER_ROLE: `${BASE_URL}/addUserRole`,
    UPDATE_USER_ROLE: `${BASE_URL}/updateUserRole`,
};

export const SKILL_URLS = {
    FETCH_SKILLS: `${BASE_URL}/getUserSkills`,
    ADD_USER_SKILL: `${BASE_URL}/addUserSkill`,
    UPDATE_USER_SKILL: `${BASE_URL}/updateUserSkill`,
};

export const PERMISSION_URLS = {
    FETCH_MENUS: `${BASE_URL}/getMenuList`,
    FETCH_ENABLED_MENUS: `${BASE_URL}/getEnabledMenus/`,
    UPDATE_MENU_PERMISSIONS: `${BASE_URL}/updatePermissions`,
};

export const TEXT_CONVERSATION_URLS = {
    FETCH_TEXT_CONVERSATION_INFO: `${BASE_URL}/getTextInfo`,
    ASSIGN_USER: `${BASE_URL}/assignUsers`,
    END_TEXT_CONVERSATION: `${BASE_URL}/endTextConversation`,
    FETCH_TEXT_CONVERSATION_BY_ID: `${BASE_URL}/getTextConversationById` ,
    UPDATE_CARA_RESPONSE_CHAT: `${BASE_URL}/updateCaraResponsechat`,
    APPROVE_SEND_CHAT: `${BASE_URL}/approveAndSendChat`,

};


export const CUSTOMER_URLS = {
    ADD_CUSTOMER: `${BASE_URL}/addCustomer`,
    UPDATE_CUSTOMER: `${BASE_URL}/updateCustomer`,
    FETCH_CUSTOMERS: `${BASE_URL}/getcustomers`,
    FETCH_CUSTOMERS_INFO: `${BASE_URL}/getcustomerinfo`,
};

export const AGENT_URLS = {
    GET_AGENT_NAME: `${BASE_URL}/userroles`,
    GET_ACTIVE_SKILLS: `${BASE_URL}/getActiveSkills`,
    GET_ACTIVE_REASONS: `${BASE_URL}/getActiveReasons`,
    SET_AGENT_AVAILABLE: `${BASE_URL}/setAgentAvailable`,
    SET_AGENT_OFFLINE: `${BASE_URL}/setAgentOffline`,
    GET_AGENT_ACTIVE_SKILLS: `${BASE_URL}/getAgentActiveSkills/`,
    GET_AGENT_OFFLINE_REASON: `${BASE_URL}/getAgentOfflineReason/`,
    GET_AGENT_STATUS: `${BASE_URL}/getAgentStatus/`,
    GET_AGENT_STATUS_HISTORY: `${BASE_URL}/getAgentStatusHistory/`,
};

export const ADMIN_URLS = {
    ADD_USER: `${BASE_URL}/adduser`,
    EDIT_USER: `${BASE_URL}/edituser`,
    FETCH_USERS: `${BASE_URL}/getusers`,
    DELETE_USER: `${BASE_URL}/deleteuser`,
    FETCH_ROLES: `${BASE_URL}/getUserRoles`,
    ADD_USER_ROLE: `${BASE_URL}/addUserRole`,
    UPDATE_USER_ROLE: `${BASE_URL}/updateUserRole`,
    FETCH_SKILLS: `${BASE_URL}/getUserSkills`,
    ADD_USER_SKILL: `${BASE_URL}/addUserSkill`,
    UPDATE_USER_SKILL: `${BASE_URL}/updateUserSkill`,
    FETCH_MENUS: `${BASE_URL}/getMenuList`,
    FETCH_ENABLED_MENUS: `${BASE_URL}/getEnabledMenus/`,
    UPDATE_MENU_PERMISSIONS: `${BASE_URL}/updatePermissions`,
};

export const EMAIL_CONVERSATION_URLS = {
    FETCH_EMAIL_CONVERSATION_INFO: `${BASE_URL}/getEmailInfo`,
    FETCH_Email_CONVERSATION_BY_ID: `${BASE_URL}/getEmailConversationById` ,
    SAVE_EMAIL_RESPONSE: `${BASE_URL}/saveEmailResponse`,
    SEND_EMAIL_RESPONSE: `${BASE_URL}/sendEmailResponse`,

    ASSIGN_USER: `${BASE_URL}/assignUsers`,
    END_TEXT_CONVERSATION: `${BASE_URL}/endTextConversation`,
};

export const CAMPAIGN_URLS = {
    FETCH_CAMPAIGN: `${BASE_URL}/getCampaigns`,
    UPDATE_CAMPAIGN: `${BASE_URL}/updateCampaign`,
    FETCH_PROCESS: `${BASE_URL}/getProcesses`,
};

export const DATA_UPLOAD_URLS = {
    UPDATE_UPLOAD_CSV: `${BASE_URL}/uploadCsvFile`,
    UPDATE_UPLOAD_CSV_CAMPAIGN: `${BASE_URL}/uploadCsvFileCampaign`,
    UPDATE_UPLOAD_CSV_USER: `${BASE_URL}/uploadCsvFileUser`,
};

export const IVR_URLS = {
    GET_IVR_CONNECTION: `${BASE_URL}/router/getIvrConnection`,
    GET_IVR_POLICY: `${BASE_URL}/router/getpolicy`,
    ADD_IVR_POLICY: `${BASE_URL}/router/createpolicy`,
    DELETE_IVR_POLICY: `${BASE_URL}/router/deletepolicy`,
    GET_IVR_QUEUE: `${BASE_URL}/router/getqueue`,
    ADD_IVR_QUEUE: `${BASE_URL}/router/createqueue`,
    DELETE_IVR_QUEUE: `${BASE_URL}/router/deletequeue`,
    GET_IVR_WORKER: `${BASE_URL}/router/getworker`,
    ADD_IVR_WORKER: `${BASE_URL}/router/createworker`,
    REMOVE_IVR_WORKER: `${BASE_URL}/router/removeworkerqueues`,
    DELETE_IVR_WORKER: `${BASE_URL}/router/deleteworker`,
    UPDATE_IVR_WORKER: `${BASE_URL}/router/updateworker`,
    GET_IVR_JOB: `${BASE_URL}/router/getjob`,
    ADD_IVR_JOB: `${BASE_URL}/router/createjob`,
    DELETE_IVR_JOB: `${BASE_URL}/router/deletejob`,
    CANCEL_IVR_JOB: `${BASE_URL}/router/closeJob`,
    ACCEPT_IVR_JOB_OFFER: `${BASE_URL}/router/acceptjob`,
    COMPLETE_IVR_ASSIGNMENT: `${BASE_URL}/router/completeassignment`,
    CLOSE_IVR_ASSIGNMENT: `${BASE_URL}/router/closeassignment`,
    GET_ACS_IDENTITY: `${BASE_URL}/router/getAgentIdentity`,
    REFRESH_ACS_IDENTITY_TOKEN: `${BASE_URL}/router/refreshAgentToken`,
    CALL_JOB_POLLING: `${BASE_URL}/router/calljobpolling`,
    IVR_INITIATE_CALL: `${BASE_URL}/router/initiatecall`,
    IVR_SERVERID_CALL: `${BASE_URL}/servercallid`,
    CHAT_JOB_POLLING: `${BASE_URL}/router/chatjobpolling`,
    REMOVE_CHAT_BOT: `${BASE_URL}/router/removechatbot`,
};

export const CUSTOMERINFO_URLS = {
    GET_CUSTOMER_NOTES: `${BASE_URL}/getcustomernotes`,
    ADD_CUSTOMER_NOTES: `${BASE_URL}/addcustomernotes`,
    GET_CUSTOMER_BY_PHONE: `${BASE_URL}/getcustomerprofilebyphone`,
    GET_CUSTOMER_BY_LASTNAME: `${BASE_URL}/getcustomerprofilebylastname`,
    GET_CUSTOMER_BY_CUSTOMERID: `${BASE_URL}/getcustomerbycustomerid`,
    GET_CUSTOMER_BY_EMAIL: `${BASE_URL}/getcustomerprofilebyemail`,
    GET_CUSTOMER_BY_GUID: `${BASE_URL}/getcustomerprofilebyguid`,
    GET_CUSTOMER_HISTORY: `${BASE_URL}/getcustomerhistory`,
    GET_CUSTOMER_TEXTS: `${BASE_URL}/getcustomertexts`,
    GET_CUSTOMER_CALLS: `${BASE_URL}/getcustomercalls`,
    GET_CUSTOMER_PAYMENTS: `${BASE_URL}/getcustomerpayments`,
    GET_CUSTOMER_CHATS: `${BASE_URL}/getcustomerchats`,
    GET_CUSTOMER_EMAILS: `${BASE_URL}/getcustomeremails`,
    GET_CUSTOMER_DATASET: `${BASE_URL}/getcustomerdataset`,
    GET_CONVERSATION_COMPLIANCE: `${BASE_URL}/getconversationcompliance`,
    GET_CONVERSATION_COMPLIANCE_FORR413 : `${BASE_URL}/getconversationcomplianceForR413`,
    GET_CUSTOMER_OPT_IN: `${BASE_URL}/getcustomeroptin`,
    UPDATE_CALL_JOB_MAPPING_BY_CUSTID: `${BASE_URL}/updatecalljobmappingbycustid`,
    ADD_CUSTOMER_RELATED_RECORD: `${BASE_URL}/addcustomerrelatedrecord`,
    SEND_TEXT_MESSAGE: `${BASE_URL}/sendtext`,
    SEND_EMAIL_MESSAGE: `${BASE_URL}/sendemail`,
    SEND_IN_TEXT_MESSAGE: `${BASE_URL}/sendintext`,
    SEND_IN_EMAIL_MESSAGE: `${BASE_URL}/sendinemail`,
};

export const AGENTINFO_URLS = {
    GET_AGENTINFO_NOTES: `${BASE_URL}/getagentnotes`,
    GET_AGENTINFO_TEXTS: `${BASE_URL}/getagenttexts`,
    GET_AGENTINFO_CALLS: `${BASE_URL}/getagentcalls`,
    GET_AGENTINFO_PAYMENTS: `${BASE_URL}/getcustomerpayments`,
    GET_AGENTINFO_CHATS: `${BASE_URL}/getagentchats`,
    GET_AGENTINFO_EMAILS: `${BASE_URL}/getagentemails`,
};

export const LOGS_URLS = {
    GET_CALL_INFO: `${BASE_URL}/calllogs`,
    GET_BACKLOG: `${BASE_URL}/getbacklog`,
};

export const SCHEDULEINFO_URLS = {
    GET_UPCOMING_SCHEDULE: `${BASE_URL}/upcomingschedule`,
    GET_UPCOMING_MESSAGES_INFO: `${BASE_URL}/upcomingmessagesinfo`,
    GET_UPCOMING_MESSAGES: `${BASE_URL}/upcomingmessages`,
    UPDATE_SCHEDULE_MESSAGE: `${BASE_URL}/updateschedulemessage`,
    GET_ARCHIVE_SCHEDULE: `${BASE_URL}/archivedschedule`,
    GET_ARCHIVE_MESSAGES: `${BASE_URL}/archivedmessages`,
    UPDATE_ALL_SCHEDULE_DATA: `${BASE_URL}/updateallscheduledata`,
    STOP_ALL_SCHEDULES: `${BASE_URL}/stopallschedules`,
};

export const RESPONSE_URLS = {
    GET_RESPONSE: `${BASE_URL}/getresponse`,
    GET_PTP_RESPONSE: `${BASE_URL}/getptpresponse`,
};

export const COMPLIANCE_STATS_URLS = {
    GET_COMPLIANCE_STATS: `${BASE_URL}/getcompliancestats`,
    GET_COMPLIANCE_STAT_INFO: `${BASE_URL}/getcompliancestatinfo`,
};

export const COMPLIANCE_URLS = {
    GET_COMPLIANCE_RULES: `${BASE_URL}/getcompliance`,
    UPDATE_COMPLIANCE_RULES: `${BASE_URL}/updatecompliance`,
};

export const INTEGRATION_URLS = {
    GET_INTEGRATION_INFO: `${BASE_URL}/getintegration`,
    GET_INTEGRATION_OPTIONS: `${BASE_URL}/getintegrationoptions`,
    UPDATE_INTEGRATION_OPTIONS: `${BASE_URL}/updateintegrationoptions`,
    RESET_INTEGRATION_OPTIONS: `${BASE_URL}/resetintegration`,
};

export const VOICEMAIL_URLS = {
    GET_PENDING_VOICEMAIL: `${BASE_URL}/getPendingVoiceMail`,
};

export const DASHBOARD_URLS = {
    GET_KEYWORD_SEARCH: `${BASE_URL}/getkeywordsearch`,
    GET_OPTIN: `${BASE_URL}/getoptin`,
    GET_LANGUAGE: `${BASE_URL}/getlanguage`,
    GET_PROMISES: `${BASE_URL}/getpromises`,
    GET_CONVERSATION_TIME: `${BASE_URL}/getconversationtime`,
    GET_DPD: `${BASE_URL}/getdpd`,
    GET_TRANSFERS_TEXT: `${BASE_URL}/gettransferstext`,
    GET_TRANSFERS_EMAIL: `${BASE_URL}/gettransfersemail`,
    GET_ACTIVITY: `${BASE_URL}/getactivity`,
    
    GET_COMPLIANCE_STATS: `${BASE_URL}/getcompliancestats`,
    GET_CUSTOMER_TEXT_CHART: `${BASE_URL}/getcustomertextchart`,
    GET_CUSTOMER_EMAIL_CHART: `${BASE_URL}/getcustomeremailchart`,
    GET_CUSTOMER_DATAUPLOAD_CHART: `${BASE_URL}/getcustomerdatauploadchart`,
    GET_CUSTOMER_DATAUPLOAD: `${BASE_URL}/getcustomerdataupload`,
    GET_CUSTOMER_CALL_CHART: `${BASE_URL}/getcustomercallschart`,
    GET_CUSTOMER_CHAT_CHART: `${BASE_URL}/getcustomerchatschart`,
    GET_LANGUAGE_CONVERSATIONS:           `${BASE_URL}/getlanguageconversations`,
    GET_OPTOUT_CONVERSATIONS:             `${BASE_URL}/getoptoutconversations`,
    GET_CONVERSATION_TIME_CONVERSATIONS:  `${BASE_URL}/getconversationtimeconversations`,
    GET_DPD_CONVERSATIONS:                `${BASE_URL}/getdpdconversations`,
    GET_TRANSFERS_CONVERSATIONS:          `${BASE_URL}/gettransfersconversations`,
    GET_HI_RESPONSES: `${BASE_URL}/gethiresponses`,
    GET_EVENT_ACTIVITY: `${BASE_URL}/getdpdactivity`,
    GET_DPD_DAY_ACTIVITY: `${BASE_URL}/getdpddayactivity`,
};

export const OUTGOING_URLS = {
    GET_PENDING_OUTGOINGCALL: `${BASE_URL}/getPendingOutgoingCall`,
    ADD_ONGOING_CALL: `${BASE_URL}/addOngoingCall`,
    COMPLETE_ONGPING_CALL: `${BASE_URL}/completeOngoingCall`,
};

export const PAYMENT_URLS = {
    FETCH_PAYMENTS: `${BASE_URL}/getpayments`,
    TAKE_PAYMENT: `${BASE_URL}/takepayment`,
    SCHEDULE_PAYMENT: `${BASE_URL}/schedulepayment`,
    FETCH_PAYMENTS_BY_CUSTOMER: `${BASE_URL}/getpaymentsbycustomer`,
    FETCH_PAYMENTS_BY_CUSTOMER_CHART: `${BASE_URL}/getpaymentsbycustomerchart`, 
    FETCH_PROMISES_BY_CUSTOMER: `${BASE_URL}/getpromisesbycustomer`,
    FETCH_PROMISES_BY_CUSTOMER_CHART: `${BASE_URL}/getpromisesbycustomerchart`,
};

export const PBI_URLS = {
    DASHBOARD_CAMPAIGNS: `${BASE_URL}/dashboard/campaigns`,

    // MTD tab — twelve day-matched periods (year / month / week) from the same
    // query the scheduled Summary report runs. Served by routes/scorecardRoutes.js,
    // which is registered separately from powerbiRoutes:
    //     app.use("/api", require("./routes/scorecardRoutes"));
    DASHBOARD_SCORECARD: `${BASE_URL}/dashboard/scorecard`,

    DASHBOARD_TEXTS:     `${BASE_URL}/dashboard/texts`,
    DASHBOARD_TIMING:    `${BASE_URL}/dashboard/timing`,
    DASHBOARD_OUTCOME:   `${BASE_URL}/dashboard/outcome`,
    DASHBOARD_HEATMAP:   `${BASE_URL}/dashboard/heatmap`,
    DASHBOARD_PASTDUE:   `${BASE_URL}/dashboard/pastdue`,
    DASHBOARD_LANGUAGE:  `${BASE_URL}/dashboard/language`,
    DASHBOARD_TRANSFERS: `${BASE_URL}/dashboard/transfers`,
    DASHBOARD_PAYMENTS_SUMMARY:      `${BASE_URL}/dashboard/payments-summary`,
    DASHBOARD_PROMISES_FULFILLMENT:  `${BASE_URL}/dashboard/promises-fulfillment`,
    DASHBOARD_ABANDONMENT:        `${BASE_URL}/dashboard/abandonment`,
    DASHBOARD_ABANDONMENT_STAGES: `${BASE_URL}/dashboard/abandonment-stages`,
    DASHBOARD_SENTIMENT_POLARITY: `${BASE_URL}/dashboard/sentiment-polarity`,
    DASHBOARD_SENTIMENT_EMOTION:  `${BASE_URL}/dashboard/sentiment-emotion`,
    DASHBOARD_SENTIMENT_SCORE:    `${BASE_URL}/dashboard/sentiment-score`,
    DASHBOARD_SENTIMENT_WILLING:  `${BASE_URL}/dashboard/sentiment-willing`,
    DASHBOARD_COMPLIANCE_SUMMARY:  `${BASE_URL}/dashboard/compliance-summary`,
    DASHBOARD_COMPLIANCE_BY_RULE:  `${BASE_URL}/dashboard/compliance-by-rule`,
    DASHBOARD_COMPLIANCE_MTD:      `${BASE_URL}/dashboard/compliance-mtd`,
    DASHBOARD_DPD_OUTCOMES: `${BASE_URL}/dashboard/dpd-outcomes`,
    DASHBOARD_DPD_TIMING:   `${BASE_URL}/dashboard/dpd-timing`,
    DASHBOARD_DPD_HEATMAP: `${BASE_URL}/dashboard/dpd-heatmap`,
    DASHBOARD_DPD_RESPONSES: `${BASE_URL}/dashboard/dpd-responses`,
    DASHBOARD_OPTOUTS:`${BASE_URL}/dashboard/optouts`,
    DASHBOARD_OPTOUTS_BY_DPD:`${BASE_URL}/dashboard/optouts-by-dpd`,
    DASHBOARD_OPTOUTS_HEATMAP:`${BASE_URL}/dashboard/optouts-heatmap`,
    DASHBOARD_OPTOUTS_SUMMARY:`${BASE_URL}/dashboard/optouts-summary`,
    DASHBOARD_PTP_SUMMARY: `${BASE_URL}/dashboard/ptp-summary`,
    DASHBOARD_PTP_BY_DPD:  `${BASE_URL}/dashboard/ptp-by-dpd`,
    DASHBOARD_PTP_BY_DAY:  `${BASE_URL}/dashboard/ptp-by-day`,
    DASHBOARD_PTP_TARGETS_BUCKET: `${BASE_URL}/dashboard/ptp-targets-bucket`,
    DASHBOARD_PTP_BY_DPD_DAY: `${BASE_URL}/dashboard/ptp-by-dpd-day`,
    DASHBOARD_PTP_AGING:   `${BASE_URL}/dashboard/ptp-aging`,
    DASHBOARD_COMPARE_TEXTS:    "/dashboard/compare-texts",
    DASHBOARD_COMPARE_PTP:      "/dashboard/compare-ptp",
    DASHBOARD_COMPARE_PAYMENTS: "/dashboard/compare-payments",
    DASHBOARD_CURE_AGING_SUMMARY: `${BASE_URL}/dashboard/cure-aging-summary`,
    DASHBOARD_CURE_AGING_BY_DPD:  `${BASE_URL}/dashboard/cure-aging-by-dpd`,
    DASHBOARD_CURE_AGING_BY_DAY:  `${BASE_URL}/dashboard/cure-aging-by-day`,
    DASHBOARD_CURE_AGING_TIMING: `${BASE_URL}/dashboard/cure-aging-timing`,
    DASHBOARD_DELINQUENCY_BY_DAY: `${BASE_URL}/dashboard/delinquency-by-day`,
    DASHBOARD_DELINQUENCY_BY_DPD: `${BASE_URL}/dashboard/delinquency-by-dpd`,
    // apiConfig.js — PBI_URLS
    DASHBOARD_DELINQUENCY_UNIQUE: `${BASE_URL}/dashboard/delinquency-unique`,
    // 24-hr Pay
    DASHBOARD_24HR_PAY:           `${BASE_URL}/dashboard/24hr-pay`,
    DASHBOARD_24HR_PAY_CALCULATE: `${BASE_URL}/dashboard/24hr-pay/calculate`,
    DASHBOARD_PTP_SUMMARY_HOURLY:    "/dashboard/hourly/ptp-summary",
    DASHBOARD_PTP_BY_DPD_HOURLY:     "/dashboard/hourly/ptp-by-dpd",
    DASHBOARD_PTP_BY_DAY_HOURLY:     "/dashboard/hourly/ptp-by-day",
    DASHBOARD_PTP_BY_DPD_DAY_HOURLY: "/dashboard/hourly/ptp-by-dpd-day",
    DASHBOARD_HEATMAP_HOURLY:        "/dashboard/hourly/heatmap",
    DASHBOARD_OUTCOME_HOURLY:        "/dashboard/hourly/outcome",
    DASHBOARD_TIMING_HOURLY:         "/dashboard/hourly/timing",
    DASHBOARD_ACCOUNTS_HOURLY:       "/dashboard/hourly/accounts",
    
    };

export const INSIGHT_URLS = {
    GET_WILLING_DATA: `${BASE_URL}/getwillingdata`,
    GET_EMOTION_DATA: `${BASE_URL}/getemotiondata`,
    GET_POLARITY_DATA: `${BASE_URL}/getpolaritydata`,
    GET_SCORE_DATA: `${BASE_URL}/getscoredata`,
    GET_ABANDON_TEXT: `${BASE_URL}/getabandontext`,
    GET_ABANDON_EMAIL: `${BASE_URL}/getabandonemail`,
    GET_ABANDON_EVENT_TEXT: `${BASE_URL}/getabandoneventtext`,
    GET_ABANDON_EVENT_EMAIL: `${BASE_URL}/getabandoneventemail`,
    GET_RESPONSE_RATE_TEXT: `${BASE_URL}/getresponseratetext`,
    GET_RESPONSE_RATE_EMAIL: `${BASE_URL}/getresponserateemail`,
    GET_EMOTION_CONVERSATIONS: `${BASE_URL}/getemotionconversations`,
    GET_POLARITY_CONVERSATIONS: `${BASE_URL}/getpolarityconversations`,
    GET_SCORE_CONVERSATIONS:   `${BASE_URL}/getscoreconversations`,
    GET_WILLING_CONVERSATIONS: `${BASE_URL}/getwillingconversations`,
    GET_ABANDON_CONVERSATIONS:       `${BASE_URL}/getabandonconversations`,
    GET_ABANDON_EVENT_CONVERSATIONS: `${BASE_URL}/getabandoneventconversations`,
};

export const COMMON_URLS = {
    GET_CLIENT_CONFIG: `${BASE_URL}/getclientconfig`,
    GET_CLIENT_TIMEZONE: `${BASE_URL}/getclienttimezone`,
};

export const REMINDER_URLS = {
    FETCH_REMINDERS:  `${BASE_URL}/reminders`,        // GET    list
    FETCH_REMINDER:   `${BASE_URL}/reminders`,        // GET    one  -> `${...}/reminders/${id}`
    CREATE_REMINDER:  `${BASE_URL}/reminders`,        // POST
    UPDATE_REMINDER:  `${BASE_URL}/reminders`,        // PUT    -> `${...}/reminders/${id}`
    TOGGLE_REMINDER:  `${BASE_URL}/reminders`,        // PATCH  -> `${...}/reminders/${id}/enabled`
    DELETE_REMINDER:  `${BASE_URL}/reminders`,        // DELETE -> `${...}/reminders/${id}`
    UPLOAD_REMINDER_EXCLUSION: `${BASE_URL}/uploadReminderExclusion`,
    CAMPAIGN_TIMES:            `${BASE_URL}/reminderCampaignTimes`,
    EXCLUSION_DAYS:            `${BASE_URL}/reminderExclusionDays`,
    GENERATE_EXCLUSION:        `${BASE_URL}/generateReminderExclusion`,
    EXCLUSION_AUDIT:           `${BASE_URL}/reminderExclusionAudit`,    
};

// ============================================================================
// PATCH FRAGMENT for src/services/apiConfig.js
// ----------------------------------------------------------------------------
// Replace your existing FORECAST_URLS block with this full version.
// Same pattern as PBI_URLS - every constant is the full URL built via the
// `${BASE_URL}` template string. Server-side these resolve under
// app.use("/api", forecastRoutes), giving host/api/forecast/...
// ============================================================================

export const FORECAST_URLS = {
    // Models
    FORECAST_MODELS:                   `${BASE_URL}/forecast/models`,

    // Channel personas (per-id endpoints use the bare URL + ID via the service layer)
    FORECAST_CHANNEL_PERSONAS:         `${BASE_URL}/forecast/channel-personas`,

    // Behavioral personas
    FORECAST_BEHAVIORAL_PERSONAS:      `${BASE_URL}/forecast/behavioral-personas`,

    // Holidays
    FORECAST_HOLIDAYS:                 `${BASE_URL}/forecast/holidays`,

    // Calendar
    FORECAST_CALENDAR:                 `${BASE_URL}/forecast/calendar`,
    FORECAST_CALENDAR_REGEN:           `${BASE_URL}/forecast/calendar/regenerate`,

    // Reference tables (read-only)
    FORECAST_DPD_BUCKETS:              `${BASE_URL}/forecast/dpd-buckets`,
    FORECAST_PTP_OUT_BUCKETS:          `${BASE_URL}/forecast/ptp-out-buckets`,
    FORECAST_CONVERSION_TYPES:         `${BASE_URL}/forecast/conversion-types`,
    FORECAST_FEATURES:                 `${BASE_URL}/forecast/features`,

    // Forecast runs
    FORECAST_RUNS:                     `${BASE_URL}/forecast/runs`,

    // Ingest
    FORECAST_INGEST_BATCHES:           `${BASE_URL}/forecast/ingest/batches`,
    FORECAST_INGEST_PULL_DBO:          `${BASE_URL}/forecast/ingest/pull-dbo-payments`,
    FORECAST_INGEST_VALIDATE:          `${BASE_URL}/forecast/ingest/validate`,
    FORECAST_INGEST_PROMOTE:           `${BASE_URL}/forecast/ingest/promote`,

    // Recompute
    FORECAST_RECOMPUTE_BEHAVIORAL:     `${BASE_URL}/forecast/recompute/behavioral-attributes`,
    FORECAST_RECOMPUTE_KEEP_RATES:     `${BASE_URL}/forecast/recompute/ptp-keep-rates`,
    FORECAST_RECOMPUTE_ASSIGNMENTS:    `${BASE_URL}/forecast/recompute/persona-assignments`,
    // Compare (baseline rollup across models, read-only)
    FORECAST_COMPARE_BASELINE:         `${BASE_URL}/forecast/compare/baseline`,
    FORECAST_CALENDAR_FACTORS: `${BASE_URL}/forecast/calendar-factors`,
    FORECAST_CHANNEL_DAY_ATTEMPTS: (id) => `${BASE_URL}/forecast/models/${id}/channel-day-attempts`,
};

// ============================================================================
// PATCH FRAGMENT for src/services/apiConfig.js
// ----------------------------------------------------------------------------
// Append this block (same style as REMINDER_URLS — bare base URL, the service
// layer appends /:id and sub-paths). Server-side these resolve under
// app.use("/api", reportRoutes).
// ============================================================================

export const REPORT_URLS = {
    // Catalog — powers the report dropdown
    FETCH_REPORT_CATALOG:    `${BASE_URL}/reports/catalog`,     // GET    list of schedulable reports
    FETCH_REPORT_DEFINITION: `${BASE_URL}/reports/catalog`,     // GET    one -> `${...}/reports/catalog/${reportId}`

    // Schedules
    FETCH_REPORT_SCHEDULES:  `${BASE_URL}/reportSchedules`,     // GET    list
    FETCH_REPORT_SCHEDULE:   `${BASE_URL}/reportSchedules`,     // GET    one    -> `${...}/${id}`
    CREATE_REPORT_SCHEDULE:  `${BASE_URL}/reportSchedules`,     // POST
    UPDATE_REPORT_SCHEDULE:  `${BASE_URL}/reportSchedules`,     // PUT    -> `${...}/${id}`
    TOGGLE_REPORT_SCHEDULE:  `${BASE_URL}/reportSchedules`,     // PATCH  -> `${...}/${id}/enabled`
    DELETE_REPORT_SCHEDULE:  `${BASE_URL}/reportSchedules`,     // DELETE -> `${...}/${id}`

    // Ad-hoc run + delivery history
    RUN_REPORT_NOW:          `${BASE_URL}/reportSchedules`,     // POST   -> `${...}/${id}/run`
    FETCH_REPORT_RUNS:       `${BASE_URL}/reportSchedules`,     // GET    -> `${...}/${id}/runs`

    // Generated artifacts (PDF / CSV download links from the run history)
    DOWNLOAD_REPORT_FILE:    `${BASE_URL}/reports/file`,        // GET    -> `${...}/${runFileId}`
};

// ============================================================================
// PATCH FRAGMENT for src/services/apiConfig.js
// ----------------------------------------------------------------------------
// Append this block. Same style as PBI_URLS — every constant is the full URL
// built via the `${BASE_URL}` template string. Server-side these resolve under
//     app.use("/api", require("./ops/opsRoutes"));
// giving host/api/ops/...
//
// NOTE ON THE TWO STYLES ALREADY IN PBI_URLS: most entries are
// `${BASE_URL}/...` while the hourly and compare-* entries are bare relative
// paths. Both work — axios treats an absolute URL as final and prefixes a
// relative one with apiClient's baseURL — but they only agree while
// apiClient.baseURL equals BASE_URL. OPS_URLS uses the explicit form
// throughout so it cannot drift if that ever stops being true.
//
// PARAM SHAPE: { startDate, endDate, granularity }. No campaign and no
// channel — Ops watches one worker's queue, which has neither dimension.
// The tenant zone is resolved server-side from clientconfig via
// getClientWinTz, so nothing zone-related is passed from here.
// ============================================================================

export const OPS_URLS = {
    // Agent Health — always NOW, takes no params. Echoes back
    // reportingTimeZone so the page can show which zone resolved.
    OPS_LIVE:                        `${BASE_URL}/ops/live`,

    // Response Speed
    OPS_RESPONSE_SPEED_SUMMARY:      `${BASE_URL}/ops/response-speed/summary`,
    OPS_RESPONSE_SPEED_TREND:        `${BASE_URL}/ops/response-speed/trend`,
    OPS_RESPONSE_SPEED_DISTRIBUTION: `${BASE_URL}/ops/response-speed/distribution`,
    OPS_RESPONSE_SPEED_SLOWEST:      `${BASE_URL}/ops/response-speed/slowest`,

    // Service Interruptions — turns that ended with the fall-back message
    OPS_INTERRUPTIONS_SUMMARY:       `${BASE_URL}/ops/interruptions/summary`,
    OPS_INTERRUPTIONS_TREND:         `${BASE_URL}/ops/interruptions/trend`,
    OPS_INTERRUPTIONS_DETAIL:        `${BASE_URL}/ops/interruptions/detail`,

    // Duplicate Watch — delivery integrity. deliveryAttemptsPerMessage on the
    // trend must read 1.000; anything higher is the condition behind
    // duplicate charges.
    OPS_DELIVERY_TREND:              `${BASE_URL}/ops/delivery/trend`,
    OPS_DELIVERY_REPEATS:            `${BASE_URL}/ops/delivery/repeats`,
    // Counted from customerconvevent (CF-AI3-PAY), not from the agent's text.
    OPS_PAYMENTS_DUPLICATES:         `${BASE_URL}/ops/payments/duplicates`,
    // Transactions with a confirmation number that appears nowhere in the
    // conversation — money moved, customer never told.
    OPS_PAYMENTS_UNCONFIRMED:        `${BASE_URL}/ops/payments/unconfirmed`,

    // Payment Activity — COUNTS OF CONFIRMATION MESSAGES, not settlements.
    // For dollar amounts use PBI_URLS.DASHBOARD_PAYMENTS_SUMMARY, which reads
    // customerconvevent. Parsing amounts out of the agent's text would
    // produce a second, disagreeing number.
    OPS_PAYMENTS_SUMMARY:            `${BASE_URL}/ops/payments/summary`,
    OPS_PAYMENTS_TREND:              `${BASE_URL}/ops/payments/trend`,
    OPS_PAYMENTS_DETAIL:             `${BASE_URL}/ops/payments/detail`,

    // Customer Experience — repeat messages are the leading indicator
    OPS_EXPERIENCE_SUMMARY:          `${BASE_URL}/ops/experience/summary`,
    OPS_EXPERIENCE_TREND:            `${BASE_URL}/ops/experience/trend`,
    OPS_EXPERIENCE_DETAIL:           `${BASE_URL}/ops/experience/detail`,

    // Daily Trend — one row per period with every headline number on it
    OPS_DAILY_TREND:                 `${BASE_URL}/ops/daily-trend`,

    // Drill-down popup. Append /:customerdataid in the service layer, the same
    // way REMINDER_URLS and REPORT_URLS handle their per-id endpoints.
    OPS_CONVERSATION:                `${BASE_URL}/ops/conversation`,

        // Spammer — one conversation sending the SAME message 5+ times. Usually
    // an auto-responder on the other end that Vera is answering in a loop.
    OPS_SPAMMERS_SUMMARY:            `${BASE_URL}/ops/spammers/summary`,
    OPS_SPAMMERS_TREND:              `${BASE_URL}/ops/spammers/trend`,
    OPS_SPAMMERS_DETAIL:             `${BASE_URL}/ops/spammers/detail`,
};

